export default "является\nили\nгде\nчто\nкак\nсколько\nдолжен\nможет"